import { z } from 'zod';
import type { GetArtistsResponse } from './artists';

const artistSchema = z
  .object({
    number: z.coerce.string().min(1),
    searchName: z.string().catch(''),
    name: z.string().catch(''),
  })
  .passthrough();

const artistsResponseSchema = z
  .object({
    value: z.array(z.unknown()),
  })
  .passthrough();

export const parseArtistsResponse = (raw: unknown): GetArtistsResponse | null => {
  const responseParsed = artistsResponseSchema.safeParse(raw);
  if (!responseParsed.success) return null;

  const value: { number: string; searchName: string; name: string }[] = [];
  for (const item of responseParsed.data.value) {
    const artistParsed = artistSchema.safeParse(item);
    if (artistParsed.success) {
      value.push(artistParsed.data);
    }
  }

  return { value };
};
